import React, { useCallback, useEffect, ChangeEvent } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import classNames from 'classnames';
import { isMobile } from 'react-device-detect';

import { Checkbox } from 'src/components/Checkbox';
import { AppButton } from 'src/components/AppButton/AppButton';
import {
  setFilter,
  setFilterFormState,
  resetFilter,
  resetFilterFormState,
} from '../store/hosLogStore';
import { getHosFilter, getHosFilterFormState } from '../store';

import './filter.scss';

interface Props {
  onClose: () => void;
}

export const Filter: React.FC<Props> = ({ onClose }) => {
  useEffect(() => {
    if (isMobile) {
      document.body.style.overflow = 'hidden';
      return (): void => {
        document.body.style.overflow = 'auto';
      };
    }
  }, []);

  const dispatch = useDispatch();
  const hosFilterData = useSelector(getHosFilter);
  const hosFilterFormState = useSelector(getHosFilterFormState);

  useEffect(() => {
    dispatch(
      setFilterFormState({
        ...hosFilterData,
      }),
    );
  }, [dispatch, hosFilterData]);

  const {
    violationsFilter,
    exceptionsFilter,
    // TODO uncomment Admin edits
    // pendingFilter,
    // rejectedFilter,
    // TODO uncomment Admin edits
    missingFilter,
    uncertifiedFilter,
  } = hosFilterFormState;

  const filtersObject: { [index: string]: boolean } = {
    ...hosFilterFormState,
  };

  const handleApply = useCallback((): void => {
    dispatch(setFilter(filtersObject));
    isMobile && onClose();
  }, [dispatch, filtersObject, onClose]);

  const onCheckboxChange = useCallback(
    (objKey: string) => (): void => {
      filtersObject[objKey] = !filtersObject[objKey];
      dispatch(setFilterFormState(filtersObject));
      !isMobile && handleApply();
    },
    [filtersObject, handleApply, dispatch],
  );

  const handleReset = useCallback(() => {
    dispatch(resetFilter());
    dispatch(resetFilterFormState());
  }, [dispatch]);

  return (
    <div className={classNames('hos-filter', { 'is-desktop': !isMobile })}>
      {isMobile && (
        <div className="hos-filter__close">
          <button onClick={onClose}>Close</button>
        </div>
      )}
      <div className="hos-filter__filters">
        <div className="hos-filter__title">Filters</div>
        <div className="hos-filter__checkbox">
          <Checkbox
            title="Logs with HOS Violations"
            name="violationsFilter"
            onChange={onCheckboxChange('violationsFilter')}
            checked={violationsFilter}
          />
          <Checkbox
            title="Logs with Exceptions"
            name="exceptionsFilter"
            onChange={onCheckboxChange('exceptionsFilter')}
            checked={exceptionsFilter}
          />
        </div>
      </div>
      <div className="hos-filter__horizontal-line">
        <div className="hos-filter__line"> </div>
      </div>
      <div className="hos-filter__filters">
        <div className="hos-filter__title-action">Logs Need Action</div>
        <div className="hos-filter__checkbox">
          {/* TODO uncomment Admin edits */}
          {/* <Checkbox*/}
          {/*  title="Logs with Pending Edits"*/}
          {/*  name="pendingFilter"*/}
          {/*  onChange={onCheckboxChange('pendingFilter')}*/}
          {/*  checked={pendingFilter}*/}
          {/* />*/}
          {/* <Checkbox*/}
          {/*  title="Logs with Rejected Edits"*/}
          {/*  name="rejectedFilter"*/}
          {/*  onChange={onCheckboxChange('rejectedFilter')}*/}
          {/*  checked={rejectedFilter}*/}
          {/* />*/}
          {/* TODO uncomment Admin edits */}
          <Checkbox
            title="Logs with Missing Info"
            name="missingFilter"
            onChange={onCheckboxChange('missingFilter')}
            checked={missingFilter}
          />
          <Checkbox
            title="Logs Uncertified"
            name="uncertifiedFilter"
            onChange={onCheckboxChange('uncertifiedFilter')}
            checked={uncertifiedFilter}
          />
        </div>
      </div>
      {isMobile && (
        <div className="hos-filter__button">
          <AppButton title="Apply" type="button" onClick={handleApply} />
          <AppButton title="Reset" type="button" secondary onClick={handleReset} />
        </div>
      )}
    </div>
  );
};
